<template>
    <div class="survey-note-form-awv">

        <p v-html="$i18n.gt('MESSAGE_REPORT_REVIEW_SIGNATURE')"></p>

        <b-form inline class="mb-3 ml-2">
            <label>
                <span v-html="$i18n.gt('HEADING_REPORT_TIME_SPENT')"></span>
            </label>
            <b-form-select class="ml-2"
                           v-model="draftSurveyNote.review_minutes">
                <option v-for="(v, i) in minuteOptions" :key="i"
                        :value="v">
                    {{ v }}
                </option>
            </b-form-select>
        </b-form>
        <b-form inline class="mb-3">
            <b-form-checkbox v-model="draftSurveyNote.cancer_screening_due"
                             value="1">
                Patient is Due for Cancer Screening:
            </b-form-checkbox>
            <b-form-input type="text" class="ml-3" placeholder="List Types"
                          v-model="draftSurveyNote.cancer_screening_types">
            </b-form-input>
        </b-form>
        <b-form inline class="mb-3">
            <b-form-checkbox v-model="draftSurveyNote.isCcm"
                             :checked="providerIsCcm">
                <span v-html="$i18n.gt('LABEL_PATIENT_IN_CCM')"></span>
            </b-form-checkbox>
        </b-form>

    </div>
</template>

<script>
    /**
     * Form for attributes specific to an AWV SurveyNote
     */
    export default {
        name: 'SurveyNoteFormAwv',
        data () {
            return {
                minuteOptions: [15, 20, 30, 40, 45, 60],
            }
        },
        computed: {
            draftSurveyNote() {
                return this.$store.state.draftSurveyNote
            },
            provider() {
                return this.$store.state.patientParticipantProvider
            },
            providerIsCcm () {
                return this.provider && this.provider.chronic_care_start != null
            }
        },
        watch: {
            'draftSurveyNote.cancer_screening_types': {
                handler: function (newVal, oldVal) {
                    if (newVal) {
                        this.draftSurveyNote.cancer_screening_due = 1
                    }
                }
            },

        }
    }
</script>

<style lang="scss">

    .survey-note-form-awv {

    }

</style>
